/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import DecisionIcon from '@atlaskit/icon/glyph/editor/decision';
import Item from './Item';
import { G200, G400, N100 } from '@atlaskit/theme/colors';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
var iconStyles = function iconStyles(showPlaceholder) {
  return function (theme) {
    return css({
      flex: '0 0 16px',
      height: '16px',
      width: '16px',
      margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-150, 12px)", " 0 0"),
      color: showPlaceholder ? "var(--ds-icon-subtle, ".concat(N100, ")") : themed({
        light: "var(--ds-icon-success, ".concat(G400, ")"),
        dark: "var(--ds-icon-success, ".concat(G200, ")")
      })({
        theme: theme
      }),
      '> span': {
        margin: "var(--ds-space-negative-100, -8px)"
      }
    });
  };
};
var DecisionItem = function DecisionItem(_ref) {
  var appearance = _ref.appearance,
    children = _ref.children,
    contentRef = _ref.contentRef,
    placeholder = _ref.placeholder,
    showPlaceholder = _ref.showPlaceholder,
    dataAttributes = _ref.dataAttributes;
  var theme = useGlobalTheme();
  var icon = jsx("span", {
    contentEditable: false,
    css: iconStyles(showPlaceholder)(theme)
  }, jsx(DecisionIcon, {
    label: "Decision",
    size: "large"
  }));
  return jsx(Item, {
    appearance: appearance,
    contentRef: contentRef,
    icon: icon,
    placeholder: placeholder,
    showPlaceholder: showPlaceholder,
    itemType: "DECISION",
    dataAttributes: dataAttributes,
    theme: theme
  }, children);
};
export default DecisionItem;